import {_} from 'lodash';
import * as ko from "knockout";
import {IMessageData, IObjectData, ISyncField, TBaseOrObservableType} from '../../index';
import {global} from "../../appContext";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import PromiseRequest from "../../req/PromiseRequest";
import {getAnyValue, getObjectDefinition, getSyncFieldValue, IObjectDefinition} from "../../util/misc";
import {REQUEST_MESSAGE} from "../../constants/Language";
import {nsTooltip} from "../../util/nsTooltip";
import {getHash} from "../../constants/RouteDefinitions";
import object_by_idHtml from './object-by-id.html?raw';

export let template = object_by_idHtml;

interface IParams {
    id: TBaseOrObservableType<number>
    manual?: boolean
    organizationId?: string
    emptyStr?: string
    linkable?: TBaseOrObservableType<boolean>
    showIcon?: boolean
    callback?: (obj: any) => void
    catchError?: (reason: string) => IMessageData
}

interface IViewObject {
    name: string,
    href?: string,
    icon?: string
    description?: string
}

export class viewModel {
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private req_getobject: PromiseRequest = new PromiseRequest('getobject');
    private data: KnockoutObservable<IViewObject | null> = ko.observable(null);
    private emptyStr: string | undefined = '—';
    private objDef: IObjectDefinition | null = null;

    constructor(private params: IParams) {
        this.params = _.defaults(params, {
            manual: false,
            linkable: false,
            organizationId: global.login.selectedOrganizationId(),
            showIcon: false,
        });
        this.kosub.subscribe(global.login.selectedOrganization, () => this.init());
        if (ko.isObservable(params.id)) {
            this.kosub.subscribe(params.id, () => {
                this.data(null);
                this.init()
            });
        }
        if ('emptyStr' in params) {
            this.emptyStr = params.emptyStr;
        }
        this.init();
    }

    private init() {
        const id = ko.unwrap(this.params.id);
        if (id) {
            this.messageData({message: REQUEST_MESSAGE});
            const manual = getAnyValue(this.params.manual);
            this.req_getobject
                .request({
                    id: ko.unwrap(this.params.id),
                    manual: manual,
                    orgnr: this.params.organizationId
                })
                .then((data: IObjectData[]) => {
                    const d = data[0];
                    if (!d) {
                        this.messageData({message: 'data not available', type: 'warning'});
                        return;
                    }
                    this.objDef = getObjectDefinition(d.type.id);
                    if (!this.objDef) {
                        return;
                    }
                    const syncfields = (d.syncfields ?? []) as ISyncField[];
                    const displayName = getSyncFieldValue(this.objDef.syncfieldDisplayName ?? [], syncfields);
                    const icon = manual ? this.objDef.iconManual : this.objDef.icon;
                    const routeId = manual ? this.objDef.routeDetailsManual : this.objDef.routeDetails;
                    const href = getAnyValue(this.params.linkable) && routeId
                        ? getHash(routeId, {id: d.id, orgnr: this.params.organizationId})
                        : null;
                    this.data({
                        ...(icon ? {icon} : {}),
                        name: displayName ?? '',
                        ...(href ? {href} : {}),
                        ...(nsTooltip.getTitle_objectdata(d) != null ? {description: nsTooltip.getTitle_objectdata(d)!} : {}),
                    });
                    if (this.params.callback) {
                        this.params.callback(d)
                    }
                    this.messageData(null);
                })
                .catch((reason: string) => {
                    if (this.params.catchError) {
                        const messageData = this.params.catchError(reason);
                        if (messageData) {
                            this.messageData(messageData);
                        }
                        return
                    } else {
                        this.messageData({message: reason, type: 'danger'});
                    }
                });
        } else {
            this.messageData(null);
        }
    }

    dispose() {
        this.kosub.unsuscribeAll();
        this.req_getobject.abort();
    }
}
